<template>
  <div>
    <draggable class="row" v-if="!disabled" :id="`images-uploader-${id}`" v-model="value" @start="drag=true" @end="drag=false">
      <div
        class="col-md-3 col-sm-6 col-upload"
        v-for="(image,index) in value"
        :key="index"
        :id="`${prefix}-col-${index}`">
        <i class="fas fa-trash-alt icon-delete" @click="deleteImage(index)"></i>
        <img
          :id="`${prefix}-image-${index}`"
          v-if="image && image.url()"
          class="image-upload"
          :class="{ 'disabled': disabled }"
          :src="image.url()"
        >
        <fp-loading v-if="image && !image.url()">test</fp-loading>
      </div>
      <div class="col-md-3 col-sm-6 col-upload">
        <div class="image-upload image-upload-icon text-center" @click="$refs.imgInput.click()" v-show="btnMode==='img'">
          <fp-loading class="icon-plus" v-if="isUploadding"/>
          <i v-else class="fas fa-plus icon-plus">
            <div class="div-text-icon-plus">เพิ่มรูปภาพใหม่</div>
          </i>
          <input
            hidden
            type="file"
            name="image"
            accept="image/*"
            multiple
            ref="imgInput"
            :disabled="isUploadding"
            @change="uploadImage"
          >
        </div>
      </div>
    </draggable>
    <button class="btn btn-primary btn-block" type="button" :disabled="isUploadding" @click="$refs.imgInput.click()" v-show="btnMode==='btn'">
      <i class="fas fa-plus" v-if="!isUploadding"></i>
      <i class="fas fa-sync-alt fa-spin" v-else></i>&nbsp;
      เพิ่มรูปภาพใหม่
    </button>
    
    

    <div
      class="modal fade"
      :id="`${prefix}-modal-${id}`"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      v-if="value.length"
    >
      <div class="modal-dialog modal-dailog-style" role="document">
        <div class="modal-content modal-content-style">
          <div class="modal-body modal-style">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fas fa-times icon-close"></i>
            </button>
            <i class="fas fa-chevron-left icon-slide-left-type3" @click="scrollBack()"></i>
            <img
              v-if="typeof(value[indexImage].url) === 'function'"
              class="div-image-modal"
              :src="value[indexImage].url()"
              :alt="value[indexImage].name()"
            >
            <img
              v-else-if="typeof(value[indexImage].url) === 'string'"
              class="div-image-modal"
              :src="value[indexImage].url"
              :alt="value[indexImage].name"
            >
            <i class="fas fa-chevron-right icon-slide-right-type3" @click="scrollNext()"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'md5'
import loadImage from 'blueimp-load-image';
export default {
  props: {
    value: {
      default: () => [],
    },
    id: {
      default: () => 'non-id-in-conponent'
    },
    disabled: {
      default: () => false
    },
    prefix: {
      default: () => 'image-show'
    },
    apiMode: {
      default: () => false
    },
    btnMode: {
      default: () => 'img'
    }
  },
  data() {
    return {
      isUploadding: false,
      indexImage: 0,
      images: []
    };
  },
  methods: {
    async uploadImage(event) {
      let quality = 70;
      let that = this;
      this.isUploadding = true;
      let options = {
          maxWidth: 1920,
          canvas: true
      };
      let files = event.target.files
      if(!this.apiMode) {
        for(let f of files) {
          //generate hash name prevent dubplicate filename
          let filename = 'image-'+md5((new Date()).toString())+'.'+f.name.split('.')[1]
          loadImage.parseMetaData(f, (data) => {
            if (data.exif) {
              options.orientation = data.exif.get('Orientation');
            }
            loadImage(f, async function(img){
                let imgURL = img.toDataURL("image/jpeg",quality/100);
                let base64 = imgURL.split('base64,')[1];
                let file = new that.Parse.File(filename, { base64: base64 });
                let images = that.value.slice();
                images.push(file);
                that.$emit('input', images);
                await file.save();
              }, options );
          });
        }
      }else{
        for(let f of files) {
          let filename = 'image-'+md5((new Date()).toString())+'.'+f.name.split('.')[1]
          let file = await this.$hawks.File(filename, f)
          file['__type'] = 'File'
          let images = this.value.slice()
          images.push(file);
          this.$emit('input', images)
        }
      }

      //reset input to ready new upload
      event.target.value = ''

      this.isUploadding = false;
    },
    deleteImage(index) {
      let images = this.value.slice()
      if (images && images !== 0) {
        images.splice(index, 1);
        this.$emit('input', images)
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    scrollBack() {
      if (this.value) {
        if (this.indexImage - 1 < 0) {
          this.indexImage = this.value.length - 1;
        } else {
          this.indexImage = this.indexImage - 1;
        }
      }
    },
    scrollNext() {
      if (this.value) {
        if (this.indexImage + 1 > this.value.length - 1) {
          this.indexImage = 0;
        } else {
          this.indexImage = this.indexImage + 1;
        }
      }
    },
    zoomIn(index) {
      this.indexImage = index;
      $(`#${this.prefix}-modal-${this.id}`).modal();
    }
  },
  watch: {
    value() {
      this.$emit('input', this.value)
    }
  }
};
</script>

<style lang="scss" scoped>
$tinColorLigth: rgba(246, 139, 37, 0.8);
$tinColorLigth-hover: rgba(246, 139, 37, 0.5);
$textColor: rgba(165, 165, 165, 0.9);
$borderColor: rgba(165, 165, 165, 0.9);
$image-slide-height: 50px;
$image-slide-width: 70px;
$shadow-selected: 0px 0px 4px 4px $tinColorLigth;
$shadow-hover: 0px 0px 4px 4px $tinColorLigth-hover;
$transition-time: 000ms;
$border-plus: 2px dotted $borderColor;

#upload-image-style {
  display: table-row;
  position: relative;
  padding: 10px 20px;
  margin: 10px 0;
  //   text-align: center;
}
.hidden {
  visibility: hidden;
  -webkit-transition-duration: 0s;
  transition-duration: 0s;
  height: 0;
}
.non-hidden {
  visibility: unset;
  -webkit-transition-duration: 0s;
  transition-duration: 0s;
}
div.div-image {
  //   text-align: center;
  height: 20vw;
  width: 20vw;
  max-width: 200px;
  max-height: 200px;
  margin: 10px;
  display: inline-flex;
}
div.col-upload {
  min-width: 100px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.image-enter {
  visibility: hidden;
  // border: 2px solid $tinColorLigth;
  // -webkit-transition-duration: $transition-time;
  // transition-duration: $transition-time;
}
.image-not-enter {
  border: 0px solid $tinColorLigth;
  // -webkit-transition-duration: $transition-time;
  // transition-duration: $transition-time;
}
.image-upload {
  text-align: center;
  object-fit: cover;
  width: 100%;
  height: 200px;
  padding: 0;
  //   border: 1px solid black;
  cursor: pointer;
  -webkit-transition-duration: $transition-time;
  transition-duration: $transition-time;
}
.image-upload:hover {
  margin-left: -5%;
  width: 110%;
  border: 2px solid $tinColorLigth;
  // transition: width margin $transition-time;
}
.image-upload-icon {
  border: $border-plus;
}
.icon-plus {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 50px;
  color: $tinColorLigth;
}
i.icon-close {
  color: #fff;
  font-size: 50px;
  position: absolute;
  right: -27px;
  top: -30px;
  padding: 5px 10px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
}
i.icon-close:hover {
  color: red;
  background-color: rgba(0, 0, 0, 0.9);
}
i.icon-delete {
  color: #fff;
  font-size: 20px;
  position: absolute;
  right: 0;
  top: 0;
  padding: 5px 8px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
}
i.icon-delete:hover {
  color: red;
  background-color: rgba(0, 0, 0, 0.8);
}
div.div-text-icon-plus {
  padding: 10px;
  font-size: 15px;
  color: $textColor;
}
.col-upload input[type="file"] {
  position: absolute;
  top: 10px;
  left: 15px;
  opacity: 0;
  text-align: center;
  object-fit: cover;
  width: 90%;
  height: 200px;
  padding: 0;
  cursor: pointer;
  //   border: 1px solid black;
}

div.modal-style {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: auto;
  max-width: 70vw;
  max-height: 80vh;
  padding: 0;
  text-align: -webkit-center;
}
img.div-image-modal {
  object-fit: contain;
  width: 100%;
  height: auto;
  max-width: 70vw;
  max-height: 80vh;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.8);
  cursor: default;
}
.modal-dailog-style {
  margin: 0;
  background: none;
}
.modal-content-style {
  margin: 10vh 15vw;
  width: 70vw;
  height: 80vh;
  background: none;
  border: none;
}
.icon-slide-left-type3 {
  position: absolute;
  padding: 20px;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
  color: rgba(255, 255, 255, 0.2);
  font-size: 50px;
}
.icon-slide-left-type3:hover {
  border-radius: 10px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
}
.icon-slide-right-type3 {
  position: absolute;
  padding: 20px;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
  color: rgba(255, 255, 255, 0.2);
  font-size: 50px;
}
.icon-slide-right-type3:hover {
  border-radius: 10px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
}

[draggable] {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  /* Required to make elements draggable in old WebKit */
  -khtml-user-drag: element;
  -webkit-user-drag: element;
}
li {
  color: black;
}
.dragging {
  opacity: 0.8;
  color: #6894d1;
}
.drag-over {
  text-decoration: underline;
}
.drag-enter {
  color: #c93742;
}

.disabled {
  cursor: not-allowed;
}
</style>


